import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=0b1960c8&scoped=true"
import script from "./Student.vue?vue&type=script&lang=js"
export * from "./Student.vue?vue&type=script&lang=js"
import style0 from "./Student.vue?vue&type=style&index=0&id=0b1960c8&prod&scoped=true&lang=css"
import style1 from "./Student.vue?vue&type=style&index=1&id=0b1960c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1960c8",
  null
  
)

export default component.exports